/**
 * Formatting utilities
 */

const numberFormatter = new Intl.NumberFormat();

export function formatNumber(number: number) {
  return numberFormatter.format(number);
}

/** Return only the narrow currency symbol (e.g. "gbp" → "£", "usd" → "$", "nzd" → "$"). */
export function getCurrencySymbol(currency: string = "usd"): string {
  const parts = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency.toUpperCase(),
    currencyDisplay: "narrowSymbol",
  }).formatToParts(0);
  return parts.find((p) => p.type === "currency")?.value ?? currency.toUpperCase();
}

/** Format integer cents as currency (e.g. 10000 → "$100"). Uses narrow symbol only (e.g. $ not NZ$). */
export function formatCurrencyCents(cents: number | null | undefined, currency: string = "usd"): string {
  if (cents == null) return "—";
  const formatter = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency.toUpperCase(),
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  return formatter.format(cents / 100);
}

/** Convert stored cents to display pounds/dollars (e.g. 2500 → 25). */
export function centsToDollars(cents: number | null | undefined): number | undefined {
  if (cents == null) return undefined;
  return cents / 100;
}

/** Convert user-entered pounds/dollars to stored cents (e.g. 25 → 2500). Returns undefined for empty/invalid. */
export function dollarsToCents(dollars: number | string | null | undefined): number | undefined {
  if (dollars === null || dollars === undefined || dollars === "") return undefined;
  const n = typeof dollars === "string" ? Number.parseFloat(dollars) : dollars;
  if (!Number.isFinite(n) || n < 0) return undefined;
  return Math.round(n * 100);
}

export function cn(...inputs: Array<string | undefined | null | false | 0>) {
  return inputs.filter(Boolean).join(" ");
}
